import { useViewStore } from '@/stores/viewStore.js';
import { Select } from '@/components/ui/Select.js';

const OPTIONS = [
  { value: 'raw', label: 'Raw height' },
  { value: 'biome', label: 'Biomes' },
  { value: 'contour', label: 'Contour' },
  { value: 'shaded', label: 'Hill-shaded' },
] as const;

export function TwoDModePicker() {
  const { twoDMode, setTwoDMode } = useViewStore();
  return <Select label="2D mode" value={twoDMode} options={OPTIONS} onValueChange={setTwoDMode} />;
}
